import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TabIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageHint } from '@components/common/PageHint.tsx';
import { financeLegacyService, FinanceLegacyCurrency } from '@services/finance-legacy.service.ts';
import { toastService } from '@services/toast.service.ts';

// Повний довідник валют (усі 174 рядки entry_currencies, не відфільтрований
// підмножину з options.currencies) - за проханням користувача "щоби у нас
// всі дані було видно". Завантажується окремо від options, свій запит.
export const FinanceLegacyCurrenciesTab: React.FC = () => {
  const [currencies, setCurrencies] = useState<FinanceLegacyCurrency[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    financeLegacyService.getCurrencies()
      .then(setCurrencies)
      .catch(() => toastService.error('Не вдалося завантажити валюти.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box data-i-doc={TabIndices.DEV_FINANCE_LEGACY_CURRENCIES}>
      <PageHint iDoc={TabIndices.DEV_FINANCE_LEGACY_CURRENCIES} />

      {loading ? (
        <Box display="flex" justifyContent="center" sx={{ mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : currencies.length === 0 ? (
        <Typography sx={{ mt: 4, textAlign: 'center' }}>Валют не знайдено.</Typography>
      ) : (
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Код</TableCell>
                <TableCell>Назва</TableCell>
                <TableCell>Курс</TableCell>
                <TableCell>Дата курсу</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currencies.map((currency) => (
                <TableRow key={currency.id}>
                  <TableCell>{currency.id}</TableCell>
                  <TableCell>{currency.caption}</TableCell>
                  <TableCell>{currency.description}</TableCell>
                  <TableCell>{currency.rate ?? '—'}</TableCell>
                  <TableCell>{currency.rateDate ? new Date(currency.rateDate).toLocaleDateString('uk-UA') : '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};
